import styled from 'styled-components';

export const Container = styled.div``;

export const SearchInnerWrapper = styled.div`
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: var(--border-radius) 0 0 var(--border-radius);
  height: 80vh;
  overflow-y: auto;
  background: var(--container-color);
  box-shadow: var(--box-shadow);
  box-sizing: border-box;
  border: 1px solid var(--border-color);

  @media (max-width: 768px) {
    margin: 0;
    height: min-content;
    overflow: visible;
  }
`;

export const Icon = styled.img`
  grid-template-rows: 1fr min-content;
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.2rem;
`;

export const InstructionWrapper = styled.div`
  margin-top: 10px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const InstructionText = styled.p`
  text-align: justify;
  font-size: 0.9rem;
  margin-top: 5px;
  > span {
    margin-right: 20px;
  }
`;

export const CloseExpanded = styled.div`
  font-size: 1rem;
  text-decoration: underline;
  cursor: pointer;
  color: white;
  user-select: none;
`;

export const CloseWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Input = styled.input`
  touch-action: manipulation;
  outline: none;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-image: initial;
  font-size: 1em;
  width: 70%;
  line-height: normal;
  padding: 16px;
  margin: 0px;
  margin-left: 10px;
  color: var(--tertiary-color);
  background: var(--input-background-color);
  border-radius: 8px 0 0 8px;
  border-width: 0px;
`;

export const Button = styled.button`
  width: 120px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:hover {
    opacity: 0.7;
  }
  align-items: center;
  padding: 0px;
  gap: 6px;
  background: var(--button-color);
  border-radius: 8px;
  padding: 10px;
  color: white;
  font-size: 1.3rem;
  cursor: pointer;
  > span {
    margin-left: 7px;
    font-size: 15px;
    vertical-align: middle;
  }
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const Alert = styled.h4`
  color: #f00;
`;
